export default __webpack_public_path__ + "static/media/uniswap.e38f528c.png";